











































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VendorValidate } from '@/models/accounting/vendor';
import { VFields } from '@/models/v-fields';
import * as jsPDF from 'jspdf';
import { Base } from '@/components/common/base';
import { paymentService } from '@/shared';

@Component({
})
export default class VendorValidatePage extends Base {
    public storeId: string = '';
    public requestId: string = '';
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public requestApproval: any = {};
    public cardDetail: any = {};
    public showDiv: boolean = false;

    public defaultProvider: string = '';
    public vendorValidate: VendorValidate = {
        federalTaxId: '',
    };
    public loading: boolean = false;
    public requestProgress: boolean = false;
    public tabOrder: number = 1;
    public mounted() {
        this.requestId = this.$route.params.requestId;
        this.formFields = [{
            key: 'federalTaxId',
            type: 'v-alynk-text-field',
            required: true,
            templateOptions: {
                counter: 10,
                label: this.$parent.$t('VendorValidatePage.taxId') as string,
                validations: 'required',
                required: true,
                loading: false,
                disabled: false,
            },
        },
        {
            key: 'amount',
            type: 'v-alynk-text-field',
            required: true,
            templateOptions: {
                counter: 10,
                label: this.$parent.$t('VendorValidatePage.amount') as string,
                validations: 'required',
                loading: false,
                required: true,
                disabled: false,
            },
        }];

        if (this.requestId) {
            this.getVendorDetails();
        }
    }

    public async getVendorDetails(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields);
            this.loading = true;
            const response = await paymentService.requestDetail(this.requestId);
            this.defaultProvider = response.provider;
            this.requestApproval = response;
        } finally {
            this.formlyHideSkeleton(this.formFields);
        }
    }

    public async submitVendorValidate(): Promise<void> {
        if (this.vendorValidate.federalTaxId && this.vendorValidate.amount) {
            try {
                this.requestProgress = true;
                const response = await paymentService.validateVendor(this.vendorValidate, this.requestId);
                this.requestApproval = response;
                this.tabOrder = 2;
                this.showDiv = true;
            } catch {
                this.tabOrder = 1;
            } finally {
                this.requestProgress = false;
            }
        } else {
            this.showAlert(false, this.$parent.$t('VendorValidatePage.alertVendorIsNotValidated'));
        }
    }

    public async generateCard(): Promise<void> {
        if (!this.requestApproval.isVendorValidated) {
            this.showAlert(false, this.$parent.$t('VendorValidatePage.alertVendorIsNotValidated'));
            return;
        }
        try {
            this.requestProgress = true;
            const response = await paymentService.generateCard(this.requestId);

            if (response.provider == 'Privacy') {
                // show card details on screen
                this.cardDetail = response.cardDetail;
                if (response.vendorDetail) {
                    this.requestApproval = response.vendorDetail;
                }
            } else {
                this.showAlert(true, 'We have queued your request for Card Generation, and card detail will be send over email');
            }

        } catch (e) {
            this.tabOrder = 2;
        } finally {
            this.requestProgress = false;
        }
    }

    public downloadFilefromBase64(base64: any, fileName: string) {
        const binaryString = window.atob(base64);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        const blob = new Blob([bytes]);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }

    public download(): void {
        if (this.requestApproval.isCardGenerated && this.cardDetail.pan) {
            // Default export is A4 paper, portrait using mm for units
            const doc = new jsPDF({
                orientation: 'p',
                unit: 'mm',
            });

            doc.setFontSize(14);
            doc.text(this.$parent.$t('VendorValidatePage.cardDetails') as string, 90, 10);
            doc.setFontSize(12);

            const descriptionX = 50;
            let marginFromTop = 30;
            const marginFromLeft = 70;
            doc.text(this.$parent.$t('VendorValidatePage.cardhash') as string, descriptionX, marginFromTop);
            doc.text(this.cardDetail.pan, descriptionX + marginFromLeft, marginFromTop);

            marginFromTop += 10;
            doc.text(this.$parent.$t('VendorValidatePage.expMonth') as string, descriptionX, marginFromTop);
            doc.text(this.cardDetail.exp_month, descriptionX + marginFromLeft, marginFromTop);

            marginFromTop += 10;
            doc.text(this.$parent.$t('VendorValidatePage.expYear') as string, descriptionX, marginFromTop);
            doc.text(this.cardDetail.exp_year, descriptionX + marginFromLeft, marginFromTop);

            marginFromTop += 10;
            doc.text(this.$parent.$t('VendorValidatePage.cvv') as string, descriptionX, marginFromTop);
            doc.text(this.cardDetail.cvv, descriptionX + marginFromLeft, marginFromTop);

            marginFromTop += 10;
            doc.text(this.$parent.$t('VendorValidatePage.spendingLimit') as string, descriptionX, marginFromTop);
            doc.text(this.cardDetail.spend_limit_display.toString(), descriptionX + marginFromLeft, marginFromTop);

            doc.save('Card_details');
        } else {
            this.showAlert(false, this.$parent.$t('VendorValidatePage.alertCardNotGenerated'));
        }
    }
}
